import { quoteList, statItems } from '@/mocks/ranking';
import SectionHeading from './SectionHeading';

const principles = [
  {
    icon: 'ri-focus-3-line',
    title: '只记录不编造',
    desc: '榜单话题均来自网友真实热议与公开动态，我们做的是把瓜摆上桌，结论永远交给每一位投票的网友。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '每票都算数',
    desc: '实时计票、透明展示，支持率与名次随真实参与即时变化，让你亲眼见证自己那一票的分量。',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: '轻松但不轻浮',
    desc: '吃瓜是快乐不是伤害。我们倡导友善讨论，不对任何个体作人身评价，开心吃瓜、理性发言。',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-10">
        <SectionHeading
          eyebrow="关于吃瓜榜单"
          title="把吃瓜，玩成一场全民投票"
          desc="吃瓜榜单是一个由网友共同票选的人气排行与趣味PK平台。我们把全网最好笑的瓜、最暖心的瓜、最离谱的瓜都搬上投票台，让你的一票成为榜单走向的一部分。"
          center
        />

        {/* stats band */}
        <div className="grid grid-cols-2 gap-4 rounded-3xl border border-background-200 bg-background-50 p-6 md:grid-cols-4 md:p-8">
          {statItems.map((s) => (
            <div key={s.label} className="text-center">
              <p className="font-display text-2xl text-primary-600 md:text-4xl">{s.value}</p>
              <p className="mt-1.5 text-xs text-foreground-500 md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>

        {/* principles */}
        <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3">
          {principles.map((p) => (
            <article key={p.title} className="rounded-3xl border border-background-200 bg-background-50 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-accent-100 text-accent-700">
                <i className={`${p.icon} text-2xl leading-none`} />
              </span>
              <h4 className="mt-4 font-display text-lg text-foreground-950">{p.title}</h4>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </article>
          ))}
        </div>

        {/* quotes */}
        <div className="mt-14 md:mt-16">
          <h3 className="mb-6 text-center font-display text-2xl text-foreground-950 md:text-3xl">
            网友<span className="text-primary-600">口碑</span>
          </h3>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            {quoteList.map((qt) => (
              <figure key={qt.name} className="flex flex-col rounded-3xl border border-background-200 bg-background-50 p-6">
                <i className="ri-double-quotes-l text-3xl text-accent-300" />
                <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">{qt.text}</blockquote>
                <figcaption className="mt-5 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-secondary-500 font-display text-background-50">
                    <i className="ri-user-smile-fill text-lg leading-none" />
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-900">{qt.name}</span>
                    <span className="block text-xs text-foreground-500">{qt.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        {/* contact */}
        <div className="mt-14 overflow-hidden rounded-3xl bg-primary-600 md:mt-16">
          <div className="grid grid-cols-1 items-center gap-6 p-8 md:grid-cols-[1.4fr_1fr] md:p-10">
            <div className="text-background-50">
              <h3 className="font-display text-2xl leading-snug md:text-3xl">想上榜、想发起PK，或想投个离谱票？</h3>
              <p className="mt-3 max-w-lg text-sm leading-relaxed text-primary-100">
                无论你是有想投票的话题，还是有想一起玩的朋友，随时联系我们。好瓜不怕晚，等你的那条一起上桌。
              </p>
            </div>
            <div className="flex flex-col items-start gap-3 md:items-end">
              <a
                href="mailto:hello@chigua-ranking.example.com"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-5 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-accent-100"
              >
                <i className="ri-mail-send-line text-lg leading-none" />
                hello@chigua-ranking.example.com
              </a>
              <p className="text-xs text-primary-100">工作日 10:00 - 19:00 在线，欢迎投稿选题</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}